export default __webpack_public_path__ + "static/media/STOLENCRED_Dashboard.0c591273.svg";